import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const SendTipIcon: React.FC<SvgProps> = ({ className }) => {
    return <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                className={className}
            >
                <g clip-path="url(#clip0_214_530)">
                    <circle cx="40" cy="40" r="40" fill="#ECF3FF" />
                    <path
                        d="M50.2318 32.5304C52.5425 32.5304 54.4158 30.6571 54.4158 28.3462C54.4158 26.0354 52.5425 24.1621 50.2318 24.1621C47.9211 24.1621 46.0479 26.0354 46.0479 28.3462C46.0479 30.6571 47.9211 32.5304 50.2318 32.5304Z"
                        stroke="#072648"
                        stroke-width="0.96"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M24.5022 43.8427C24.7673 43.8427 24.9822 44.0576 24.9822 44.3227C24.9822 44.5878 24.7673 44.8027 24.5022 44.8027C24.2371 44.8027 24.0222 44.5878 24.0222 44.3227C24.0222 44.0576 24.2371 43.8427 24.5022 43.8427Z"
                        stroke="#072648"
                        stroke-width="0.96"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M27.9585 43.4388L33.5509 41.907C34.2133 41.7202 34.9164 41.7261 35.5758 41.9274L45.2442 44.8812C45.899 45.0813 46.5133 45.3954 47.0588 45.8091L47.3165 46.0045C48.5316 46.9259 48.0404 48.8551 46.5327 49.0833C46.3351 49.1133 46.1339 49.1086 45.9379 49.0696L37.441 47.3779"
                        stroke="#072648"
                        stroke-width="0.96"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M47.9447 48.0328L54.7421 43.2012C55.953 42.3142 57.6511 42.5768 58.538 43.7877L52.621 50.4115C51.7012 51.4411 50.5828 52.2741 49.3328 52.8604L45.674 54.5765C43.9173 55.4005 41.9627 55.7084 40.0378 55.4644L27.448 53.8684"
                        stroke="#072648"
                        stroke-width="0.96"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M21.4622 41.1234H25.9221C26.7293 41.1234 27.3822 41.6752 27.3822 42.3522V53.8123C27.3822 54.4916 26.7265 55.0411 25.9221 55.0411H21.4622V41.1211V41.1234Z"
                        stroke="#072648"
                        stroke-width="0.96"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M44.2561 41.0274C40.5594 41.0274 37.5513 38.0192 37.5513 34.3223C37.5513 30.6254 40.5594 27.6172 44.2561 27.6172C47.9528 27.6172 50.9609 30.6254 50.9609 34.3223C50.9609 38.0192 47.9528 41.0274 44.2561 41.0274Z"
                        fill="white"
                    />
                    <path
                        d="M44.2563 28.3456C47.5562 28.3456 50.2317 31.0213 50.2317 34.3213C50.2317 37.6213 47.5562 40.297 44.2563 40.297C40.9564 40.297 38.2809 37.6213 38.2809 34.3213C38.2809 31.0213 40.9564 28.3456 44.2563 28.3456ZM44.2563 26.8867C40.1569 26.8867 36.822 30.2218 36.822 34.3213C36.822 38.4208 40.1569 41.7559 44.2563 41.7559C48.3556 41.7559 51.6905 38.4208 51.6905 34.3213C51.6905 30.2218 48.3556 26.8867 44.2563 26.8867Z"
                        fill="white"
                    />
                    <path
                        d="M44.2564 40.297C47.5565 40.297 50.2318 37.6216 50.2318 34.3214C50.2318 31.0211 47.5565 28.3457 44.2564 28.3457C40.9563 28.3457 38.281 31.0211 38.281 34.3214C38.281 37.6216 40.9563 40.297 44.2564 40.297Z"
                        stroke="#55ADED"
                        stroke-width="0.96"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_214_530">
                        <rect width="80" height="80" rx="40" fill="white" />
                    </clipPath>
                </defs>
            </svg>
};

export default SendTipIcon;
